<script lang="ts">
  import Spacer from "@/components/spacer.svelte";
  import SubNav from "@/views/bandiburri/subnav.svelte";
  import { Route } from "svelte-router-spa";
  import { Container } from "sveltestrap";

  export let currentRoute;
  export let params;
</script>

<Route {currentRoute} {params} />
<SubNav {currentRoute} />

<Container>
  <div class="mainview">
    <div class="imgarea">
      <img
        src="/images/bandiburri/introduce/brand_introduce.jpg"
        alt="브랜드 소개"
      />
    </div>
  </div>
</Container>
